import GeneratedCode from './GeneratedCode'
export default GeneratedCode